var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolvoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "338.75pt",
    height: "338.72pt",
    viewBox: "0 0 338.75 338.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 158.457031 178.015625 L 185.871094 178.011719 L 185.871094 168.867188 L 182.859375 168.867188 C 182.859375 172.367188 180.296875 174.949219 176.390625 174.949219 L 172.171875 174.949219 L 172.171875 161.289063 L 176.71875 161.289063 L 176.71875 158.265625 L 158.457031 158.261719 L 158.460938 161.289063 L 163.058594 161.289063 L 163.066406 174.953125 L 158.457031 174.953125 L 158.457031 178.015625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 199.046875 178.027344 L 209.710938 178.039063 L 218.761719 161.296875 L 223.300781 161.296875 L 223.300781 158.261719 L 209.652344 158.261719 L 209.652344 161.296875 L 213.597656 161.296875 L 207 173.484375 L 200.320313 161.296875 L 205.113281 161.296875 L 205.105469 158.261719 L 185.308594 158.261719 L 185.304688 161.296875 L 189.835938 161.296875 L 199.046875 178.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 103.878906 158.261719 L 84.074219 158.261719 L 84.070313 161.296875 L 88.605469 161.296875 L 97.816406 178.027344 L 108.480469 178.039063 L 117.53125 161.296875 L 122.070313 161.296875 L 122.070313 158.261719 L 108.417969 158.261719 L 108.417969 161.296875 L 112.363281 161.296875 L 105.769531 173.484375 L 99.089844 161.296875 L 103.882813 161.296875 L 103.878906 158.261719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 143.652344 168.210938 C 143.589844 171.800781 142.105469 175.539063 138.660156 175.480469 C 135.3125 175.417969 133.839844 171.714844 133.902344 168.039063 C 133.96875 164.230469 135.792969 160.90625 138.925781 160.960938 C 142.066406 161.019531 143.722656 164.402344 143.652344 168.210938 Z M 124.71875 168.160156 C 124.71875 173.980469 129.410156 178.617188 138.8125 178.617188 C 148.214844 178.617188 152.855469 173.980469 152.855469 168.160156 C 152.855469 162.421875 147.933594 157.84375 138.761719 157.84375 C 129.589844 157.84375 124.71875 162.421875 124.71875 168.160156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 240.128906 160.960938 C 243.265625 161.019531 244.921875 164.402344 244.855469 168.210938 C 244.789063 171.800781 243.304688 175.539063 239.863281 175.480469 C 236.511719 175.417969 235.039063 171.714844 235.101563 168.039063 C 235.167969 164.230469 236.992188 160.90625 240.128906 160.960938 Z M 225.917969 168.160156 C 225.917969 173.980469 230.609375 178.617188 240.011719 178.617188 C 249.414063 178.617188 254.054688 173.980469 254.054688 168.160156 C 254.054688 162.421875 249.132813 157.84375 239.960938 157.84375 C 230.789063 157.84375 225.917969 162.421875 225.917969 168.160156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 261.984375 105.304688 L 250.515625 116.773438 C 260.347656 131.945313 266.0625 150.035156 266.0625 169.460938 C 266.0625 223.03125 222.632813 266.460938 169.0625 266.460938 C 115.492188 266.460938 72.0625 223.03125 72.0625 169.460938 C 72.0625 115.890625 115.492188 72.460938 169.0625 72.460938 C 188.535156 72.460938 206.667969 78.203125 221.863281 88.082031 L 233.328125 76.613281 C 215.089844 63.964844 192.945313 56.542969 169.0625 56.542969 C 106.699219 56.542969 56.144531 107.097656 56.144531 169.460938 C 56.144531 231.824219 106.699219 282.378906 169.0625 282.378906 C 231.425781 282.378906 281.980469 231.824219 281.980469 169.460938 C 281.980469 145.628906 274.589844 123.523438 261.984375 105.304688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 225.863281 60.984375 L 225.859375 64.152344 C 232.714844 67.863281 239.152344 72.238281 245.121094 77.164063 L 229.03125 93.253906 C 235.101563 98.015625 240.585938 103.488281 245.355469 109.554688 L 261.429688 93.480469 C 266.359375 99.460938 270.734375 105.914063 274.449219 112.65625 L 277.539063 112.660156 L 277.539063 60.984375 L 225.863281 60.984375 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolvoLogo);
export default __webpack_public_path__ + "static/media/volvo-logo.ba0f6885dabde7037acd8ce1ac4fc344.svg";
export { ForwardRef as ReactComponent };